import { render, staticRenderFns } from "./ModifyLog.vue?vue&type=template&id=f4bb66ec&scoped=true"
import script from "./ModifyLog.vue?vue&type=script&lang=js"
export * from "./ModifyLog.vue?vue&type=script&lang=js"
import style0 from "./ModifyLog.vue?vue&type=style&index=0&id=f4bb66ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bb66ec",
  null
  
)

export default component.exports